module.exports = __webpack_public_path__ + "static/media/Ananya.a2b9e9ad.bin";